<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import AboutProductLabel from '~/components/modal-windows/AboutProductLabel.vue'
import { type ProductLabel as ProductLabelEnum, ProductLabelUtils } from '~/enums/product-label'
import type { ProductData, ProductLabel } from '~/types/products'

const props = withDefaults(
  defineProps<{
    isProductCard?: boolean
    isProductPage?: boolean
    productData: ProductData
  }>(),
  { isProductCard: false, isProductPage: false }
)

const productLabels = computed(() => {
  const { meta } = props.productData
  let labels: ProductLabel[] = Array.isArray(meta.labels) ? [...meta.labels] : []

  if (props.isProductCard) {
    labels = labels.filter((x: any): boolean => !hasDescription(x.title))
  }

  return labels

  // return labels.length ? [labels[0]] : []
})

function hasDescription (productLabel: ProductLabelEnum): boolean {
  return ProductLabelUtils.hasDescription(productLabel)
}

async function onProductLabelClick (productLabel: ProductLabelEnum): Promise<void> {
  if (!ProductLabelUtils.hasDescription(productLabel)) {
    return
  }

  await useModal({ component: AboutProductLabel, attrs: { productLabel } }).open()
}
</script>

<template>
  <div
    v-if="productLabels.length"
    class="absolute bottom-[12px] left-[12px] z-[2] -m-0.5 flex min-h-px min-w-px flex-col items-start"
    :class="{ '!bottom-unset relative !left-0 !top-0 z-auto ml-0 !flex-row': isProductPage }"
  >
    <div
      v-for="{ backgroundColor, color, title } in productLabels"
      :key="title"
      class="m-0.5 flex select-none items-center justify-center whitespace-nowrap rounded-[4px] px-2 py-1"
      :class="{
        'cursor-pointer': hasDescription(title as ProductLabelEnum),
        'leading-[16px]': isProductCard,
        '!mr-2 !rounded-[8px] !py-3 text-xs md:!rounded-xl md:text-sm': isProductPage
      }"
      :style="{ backgroundColor, color }"
      @click.prevent="onProductLabelClick(title as ProductLabelEnum)"
    >
      {{ title }}

      <SvgIcon
        v-if="hasDescription(title as ProductLabelEnum)"
        class="-m-0.5 -mr-1 !text-base"
        :class="{ '!m-0 !ml-1 !fill-transparent': isProductPage }"
        :name="isProductPage ? 'outlined/ui-next-arrow' : 'outlined/navigate-next'"
      />
    </div>
  </div>
</template>
